<div class="search-tools">
  <kendo-textbox
    #searchBox
    [clearButton]="true"
    (keydown.enter)="search()"
    [(ngModel)]="searchText"
    fillMode="flat"
    placeholder="{{ 'search' | localize }}"
    class="fullWidth"
  >
    <ng-template kendoTextBoxSuffixTemplate>
      <kendo-textbox-separator></kendo-textbox-separator>
      <button fillMode="flat" kendoButton look="clear" icon="search" (click)="search()"></button>
    </ng-template>
  </kendo-textbox>
  <button *ngIf="!isPublic" mat-button color="primary" (click)="add()">Добавить</button>
</div>
<div class="news-feed">
  <div #gridList class="news-zone">
    <kendo-icon *ngIf="loading; else grid" class="loader" name="loading" size="xlarge"></kendo-icon>
    <ng-template #grid>
      <div class="w-100" *ngIf="hasGroups && !isSearched; else solid">
        <div class="w-100" *ngFor="let group of groups()">
          <div *ngIf="!!getGroupItems(group.value)?.length">
            <div class="w-75 group-title">{{ group.title }}</div>
            <ng-container *ngTemplateOutlet="groupBlock; context: { list: getGroupItems(group.value) }"></ng-container>
          </div>
          <div *ngIf="!getGroupItems(group.value)?.length && !isSearched" #noRecords>
            <h5 *ngIf="false">
              <strong class="text-danger">Нет записей в разделе «{{ group.title }}»</strong>
            </h5>
            <div *ngIf="isPublic" class="w-75 group-title">{{ group.title }}</div>
          </div>
        </div>
      </div>
      <ng-template #solid>
        <ng-container *ngTemplateOutlet="groupBlock; context: { list: data }"></ng-container>
      </ng-template>
    </ng-template>
  </div>
  <kendo-datapager
    *ngIf="!isSearched && !groupSeparator"
    class="footer-pager"
    [style.width.%]="100"
    [pageSizeValues]="pagerConfig.pageSizes"
    [pageSize]="dataSource?.state.pageSize"
    [skip]="dataSource?.state.skip"
    [total]="dataSource.total"
    [type]="pagerConfig.type"
    [previousNext]="pagerConfig.previousNext"
    (pageChange)="onPageChange($event)"
  >
  </kendo-datapager>
</div>

<!-- Шаблон секции карточек -->
<ng-template #groupBlock let-list="list">
  <mat-grid-list
    *ngIf="list?.length > 0; else noList"
    class="fullWidth"
    [cols]="columnsCount"
    [rowHeight]="withPreview ? 410 : 210"
  >
    <mat-grid-tile *ngFor="let singleRecord of list" [colspan]="1" [rowspan]="1">
      <app-preview-card
        [sourceUrl]="sourceUrl"
        [primary]="primary"
        [customActions]="customActions"
        [withPreview]="withPreview"
        [dataItem]="singleRecord"
        [editable]="!isPublic"
        (deleteEvent)="onDelete($event)"
      ></app-preview-card>
    </mat-grid-tile>
  </mat-grid-list>
  <ng-template #noList>
    <h5>
      <strong *ngIf="!isPublic" class="text-danger">Нет записей</strong>
    </h5>
  </ng-template>
  <div class="not-found" *ngIf="!data?.length && isSearched">По запросу «{{ lastSearchText }}» ничего не найдено</div>
</ng-template>
